$(document).ready(function () {
	/*START:    Function declirations for the Cart Logic */
	/**
	 * [Sets cart in session storage on the browser]
	 * @param  {object} sessionStorage
	 */

	/**
	* Initialize cart if not already initalized
	*/
	var retrive_cart = function () {
		if (sessionStorage.getItem('cart') === null) {
			sessionStorage.setItem('cart', JSON.stringify({}));
		}
		return JSON.parse(sessionStorage.getItem('cart'));
	}
	/**
	 * Get the goal ID
	 */
	var goal_type = function () {
		return $('.price-target').attr('data-goal-type');
	}

	/**
	 * count the number of items in the cart
	 */
	var count_cart_qt = function () {
		let cart = retrive_cart();
		let qt = 0;
		for (let key in cart) {
			qt = parseInt(qt) + parseInt(cart[key].quantity);
		}
		return qt;
	}

	/**
	 * Reaches out to the end point for setting the price on the shop. 
	 */
	var get_shop_price = function () {
		$.ajax({
			url: "/wp-json/wewo/v2/shop-pricing-break",
			method: "POST",
			data: {
				goal_id: goal_type(),
				qt: count_cart_qt()
			},
			success: function (result) {
				$('.price-target-hide').css('display', 'none');
				$("." + result).css('display', 'block');
			},
			error: function (er) {

			},
		});
	}
	get_shop_price();

	var evaluate_cart = function () {
		$.ajax({
			url: "/wp-json/wewo/v2/evaluate-cart",
			method: "POST",
			//async: false,
			data: {
				cart: JSON.stringify(retrive_cart()),
				goal_id: goal_type()
			},
			beforeSend: function () {
				$('.loading-indicator').addClass('show');
			},
			success: function (result) {
				sessionStorage.setItem('cart', result);
				$('.loading-indicator').removeClass('show');
			},
			error: function (er) {
				$('.loading-indicator').removeClass('show');
			},
		});

	}

	/**
	 * Tests if a number is degetive and returns a zero
	 * @param  {Int} val
	 * @return {Int} a zero
	 */
	var not_neg = function (val) {
		if (val <= 0) {
			return 0;
		} else {
			if (isNaN(val)) {
				return 0;
			}
			return val;
		}

	}

	/**
	 * Gets the variables from the url
	 * @param  index The variable from the URL you want
	 * @return The Variable
	 */
	var get_varibales = function (index) {
		var $_GET = {};
		if (document.location.toString().indexOf('?') !== -1) {
			var query = document.location
				.toString()
				// get the query string
				.replace(/^.*?\?/, '')
				// and remove any existing hash string (thanks, @vrijdenker)
				.replace(/#.*$/, '')
				.split('&');

			for (var i = 0, l = query.length; i < l; i++) {
				var aux = decodeURIComponent(query[i]).split('=');
				$_GET[aux[0]] = aux[1];
			}
		}
		//get the 'index' query parameter
		return $_GET[index];
	}


	/**
	 * Stripe requires a werid format for money
	 * @param   num Money formated number exp: 2.50
	 * @return {string} a string with numbers and other charecters stripped. exp: 250
	 */
	var prepare_for_stripe = function (num) {
		if (isNaN(num)) {
			num = 0;
		}
		var str = num.toString();
		var numarray = str.split('.');
		var a = new Array();
		a = numarray;

		return "" + a[0] + a[1] + "";
	}

	/**
	 * Gets the total cart
	 * @param  cart cart object from the session
	 * @return {int} total cart
	 */
	var total_cart = function (cart) {
		var total = 0;
		for (var key in cart) {
			if (cart.hasOwnProperty(key)) {
				total = total + (not_neg(cart[key].quantity) * cart[key].price)
			}
		}

		if (isNaN(total)) {
			total = 0;
		}
		return total.toFixed(2);
	}

	/**
	* Calculates the grand total It also sets then in the display and form to be passed to stripe
	* @param  {float} ga gift amount
	* @param  {float} pa Product amount
	* @param  {float} sa shipping amount
	* @return {float}    returns the grand total
	*/
	var grand_total = function (ga, pa, sa) {
		console.log(ga, pa, sa);
		let product_total = ga + pa;
		let shipping = $("input[name='shipping-type']:checked").val();
		if (shipping == 'host') {
			sa = 0;
		}
		$("#shipping_charged").val(sa);
		var g_total = 0;
		if (get_varibales("campaignid") == 0) {
			var tax = 0 * (product_total + sa);
			g_total = ga + pa + sa + tax;
		} else {
			var tax = 0 * (product_total + sa);
			var state = $('.stateselect').val();
			if (state == "FL") {
				var tax = 0.065 * (pa + sa);
			} else if (state == "NC") {
				var tax = 0.075 * (pa + sa);
			}
			g_total = ga + pa + sa + tax
		}
		if (isNaN(g_total.toFixed(2))) {
			g_total = 0;
		}
		return g_total.toFixed(2);
	}

	/**
  * Handles the change event of the state select element. 
  * When the state is changed, it fetches the counties for the selected state and
  *  populates the county select element. It also updates the total amount charged based on
  *  the selected state and shipping type.
  */
	$(".stateselect").on("change", function () {
		var shipping = $("input[name='shipping-type']:checked").val();
		$('.total-amount-charge').html("$" + grand_total(total_gift_amount(retrive_cart()), total_product_amount(retrive_cart()), total_shipping(retrive_cart(), shipping)));
	});
		/*
		var selectedState = $(this).val();

		if (selectedState) {
			$.ajax({
				url: "/wp-json/wewo/v2/get-counties",
				method: "POST",
				dataType: "JSON",
				data: { state: selectedState },
				beforeSend: function () {
					$('.loading-indicator').addClass('show');
				},
				success: function (data) {
					//$('.loading-indicator').removeClass('show');
					//$(".countyselect").empty().append('<option value="">Select a county</option>');
				  				  
					if (data.length > 0) {
					  $.each(data, function (index, countyObject) {
						if (countyObject.state_id === selectedState) { // Check for matching state_id
						  $(".countyselect").append('<option value="' + countyObject.county + '">' + countyObject.county + '</option>');
						}
					  });
					} else {
					 // $(".countyselect").append('<option value="0">No Counties Found</option>');
					}
				  },
				   
				error: function (er) {
					console.log("Error fetching counties", er);
				}
			});
		} else {
		//	$(".countyselect").empty();
		}
	});

	/*
	 * @param  {object} cart     the cart from session
	 * @param  {[type]} shipping Shipping
	 * @return {[type]}          [description]
	 */
	var total_shipping = function (cart, shipping) {
		var product_total = 0;

		for (var key in cart) {
			if (cart.hasOwnProperty(key)) {
				product_total = +product_total + not_neg(+cart[key].quantity)
			}
		}

		if (shipping == 'host') {
			var shipping_cost = 0;
		}

		if (product_total >= 1 && product_total <= 4) {
			var shipping_cost = 6.00;
		}

		if (product_total >= 5 && product_total <= 10) {
			var shipping_cost = 8.50;
		}

		if (product_total >= 11 && product_total <= 14) {
			var shipping_cost = 10.00;
		}

		if (product_total >= 15 && product_total <= 24) {
			var shipping_cost = 15.00;
		}

		if (product_total >= 25 && product_total < 50) {
			var shipping_cost = 20.00;
		}
		
		if (product_total >= 50 && product_total <= 99 ) {
			var shipping_cost = 25.00;
		}

		if (product_total >= 100) {
			var shipping_cost = 30.00;
		}

		if (isNaN(shipping_cost)) {
			shipping_cost = 0;
		}
		return shipping_cost;
	}

	var total_product_amount = function (cart) {
		var product_amount = 0;
		for (var item in cart) {
			if (cart.hasOwnProperty(item)) {

				product_amount = product_amount + (cart[item].product * not_neg(cart[item].quantity));
			}
		}

		if (isNaN(product_amount)) {
			prodcut_amount = 0;
		}
		return product_amount;
	}

	var total_gift_amount = function (cart) {
		var gift_amount = 0;
		for (var item in cart) {
			if (cart.hasOwnProperty(item)) {
				gift_amount = gift_amount + (cart[item].gift * not_neg(cart[item].quantity));
			}
		}

		if (isNaN(gift_amount)) {
			gift_amount = 0;
		}
		return gift_amount;
	}

	/**
	 * Checks if the purchase button can be displayed
	 * and and runs the proper commands
	 *
	 * var stripe_formated_value = prepare_for_stripe(grand_total(total_gift_amount(JSON.parse(sessionStorage.cart)), total_product_amount(JSON.parse(sessionStorage.cart)), total_shipping(JSON.parse(sessionStorage.cart), shipping)));
	 var zeroCheck = isNaN(stripe_formated_value);
	 console.log($('.total-amount-charge').text());
	check_the_button
	 * */

	// Verify Email and Format
	var email = $('#their_email');
	var emailVerified = false;
	var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

	email.on('keyup', function () {
		emailCheck();
	})

	function emailCheck() {
		if (email.val() != '' && email.val().match(mailformat) !== null) {
			emailVerified = true;
			$(".email-required").css("display", 'none');
			check_the_button();
		} else {
			emailVerified = false;
			$(".email-required").css("display", 'block');
			check_the_button();
		}
	}

	// Check and verify recipient
	//var recipient = $('#sock_recipient');
	//recipient.on('keyup', function () {
	//	recipientCheck();
	//})

	//function recipientCheck() {
	//	if (recipient.val() != '') {
	//		$(".recipient-required").css("display", 'none');
	//		check_the_button();
	//	} else {
	//		$(".recipient-required").css("display", 'block');
	//		check_the_button();
	//	}
	//}

	function check_quantity() {
		var total = 0;
		$("input[type='number']").each(function () {
			total = parseInt($(this).val()) + total;
		})
		if (total == 0) {
			$('#amount-required').css('display', 'block')
		} else {
			$('#amount-required').css('display', 'none')
		}
		return total;
	}

	if (typeof email.val() != 'undefined') {
		check_quantity()
		nameCheck()
		//recipientCheck()
		emailCheck();
	}

	function check_the_button() {
		let cartTotal = total_cart(retrive_cart());
		var theButton = $('#customButton');
		var name = $('#first_name').val();
		var shipping = $("input[name='shipping-type']:checked").val();
		var quantity = check_quantity();
		if (shipping == 'host' && name != '' && emailVerified /*&& recipient != ''*/ && quantity != 0) {
			theButton.css('display', 'block');
		} else if (shipping == 'home' && name != '' && emailVerified && quantity != 0) {
			theButton.css('display', 'block');
		} else {
			theButton.css('display', 'none');
		}
		$('.total-amount-charge').html("$" + grand_total(total_gift_amount(retrive_cart()), total_product_amount(retrive_cart()), total_shipping(retrive_cart(), shipping)));
	}




	/*END:   Functions for the Cart Logic  */
	/*-----------------------------------------------------------------------------------------------*/
	/*START:    Start Cart Logic */
	/* ATS:Note : Listener for the checkout button */
	/*$('input').on('focusout, mouseout, change, keyup, keydown', function() {
		check_the_button();
	});
	*/

	$('.name_input').on('keyup', function () {
		nameCheck()
	})

	function nameCheck() {
		if ($('#first_name').val() != '' && $('#last_name').val() != '') {
			$(".name-required").css("display", 'none');
			check_the_button();
		} else {
			$(".name-required").css("display", 'block');
			check_the_button();
		}
	}

	$("input[type='number']").on('change', function () {
		check_the_button();
	})



	/* ATS:Note : This test the shipping type.  */
	var shipping = $("input[name='shipping-type']:checked").val();

	$("input[name='shipping-type']").on('click', function () {


		shipping = $(this).val()
		var stripe_formated_value = prepare_for_stripe(grand_total(total_gift_amount(retrive_cart()), total_product_amount(retrive_cart()), total_shipping(retrive_cart(), shipping)));
		$('.total-amount').html("$" + total_cart(retrive_cart()));
		$('.shipping-total').html("$" + total_shipping(retrive_cart(), 'home').toFixed(2));
		$('.stripe-button').attr("data-amount", prepare_for_stripe(grand_total(total_gift_amount(retrive_cart()), total_product_amount(retrive_cart()), total_shipping(retrive_cart(), shipping))));
		$('.stripe_formated_amount').val(stripe_formated_value);
		$('.total-amount-charge').html("$" + grand_total(total_gift_amount(retrive_cart()), total_product_amount(retrive_cart()), total_shipping(retrive_cart(), shipping)));
		console.log(shipping);
		if (shipping == 'host') {
			$(".purchase_recipent").css('display', 'block');
			return 0;
		} else {
			$(".purchase_recipent").css('display', 'none');
			//$('.recipient-alert').css('display', 'none');
		}
		$.ajax({
			url: "/wp-json/wewo/v2/evaluate-cart",
			method: "POST",
			//async: false,
			data: {
				cart: JSON.stringify(retrive_cart()),
				goal_id: goal_type()
			},
			beforeSend: function () {
				$('.loading-indicator').addClass('show');
			},
			success: function (result) {
				sessionStorage.setItem('cart', result);
				$('.loading-indicator').removeClass('show');
			},
			error: function (er) {
				$('.loading-indicator').removeClass('show');
			},
		});
	});

	/* -----------------------------------
	ATS:Notes
 
	The button can only show if both the
	amount is not nan and the name is filled in.
	--------------------------------------*/
	/* ATS:Note : This tests the name field. */



	$('.WHTadd-to-cart').on('click', function (e) {
		setTimeout(function () {
			
		
		var cart = retrive_cart();
		var pq = $('.product-quantity')
		cart[pq.attr('name')] = {
			'quantity': not_neg(pq.val()),
			'price': pq.attr('data-product-cost'),
			'gift': pq.attr('data-product-gift-amount'),
			'product': pq.attr('data-product-product-amount')
		};
		cart = JSON.stringify(cart);
		sessionStorage.setItem('cart', cart);
		$.ajax({
			url: "/wp-json/wewo/v2/evaluate-cart",
			method: "POST",
			//async: false,
			data: {
				cart: JSON.stringify(retrive_cart()),
				goal_id: goal_type()
			},
			beforeSend: function () {
				$('.loading-indicator').addClass('show');
			},
			success: function (result) {
				get_shop_price();
				sessionStorage.setItem('cart', result);
				alert("Added To Your Cart");
				let cartTotal = total_cart(retrive_cart());
				if (sessionStorage.getItem("cart") !== null) {
					if (!jQuery.isEmptyObject(retrive_cart())) {
						$('.WHT-Complete-Order').css('display', 'block');
						check_the_button();
					} else {
						$('.WHT-Complete-Order').css('display', 'none');
						check_the_button();
					}
				}
				$('.total-amount-charge').html("$" + grand_total(total_gift_amount(retrive_cart()), total_product_amount(retrive_cart()), total_shipping(retrive_cart(), shipping)));
				$('.loading-indicator').removeClass('show');
			},
			error: function (er) {
				$('.loading-indicator').removeClass('show');
			},
		});
	}, 500);
	});

	function updateCart(e) {

		/**
		 * TODO Functionality for if items are switching to reset item amount. 
		 * 
		 */

		// Retrieve the current cart from the session.
		var cart = retrive_cart();

		// Get the element with class 'product-quantity'.
		var pq = $('.product-quantity');

		if (e.data.addToCart) {
			console.log('Add to Cart');

			// Update the cart object with the selected product's information.
			cart[pq.attr('name')] = {
				'quantity': not_neg(pq.val()), // Call 'not_neg' function to ensure a non-negative quantity value.
				'price': pq.attr('data-product-cost'),
				'gift': pq.attr('data-product-gift-amount'),
				'product': pq.attr('data-product-product-amount')
			};

			// Convert the 'cart' object to a JSON string.
			console.log(cart);
			cart = JSON.stringify(cart);

			// Store the updated cart in the session.
			sessionStorage.setItem('cart', cart);

			$('.refined-to-checkout').css('display', 'inline-flex'); // Show a checkout button.
			$('.refined-added-to-cart').css('display', 'block'); // Show an element with class 'refined-added-to-cart'.
			$('.refined-added-to-cart').fadeOut(2000);

			$('.refined-btn-clear-item').css('display', 'inline-flex'); //Remove item from cart button displays

		}

		// If it's the second event (.refined-btn-increase-quantity), increase the quantity.
		if (e.data.increase) {
			var currentValue = parseInt(pq.val());
			pq.val(not_neg(currentValue + 1));
		}

		// decrease the quantity.
		if (e.data.decrease) {
			var currentValue = parseInt(pq.val());
			pq.val(not_neg(currentValue - 1));
		}

		if (e.data.clear) {

			$('.refined-item-cleared').css('display', 'block'); // Show an element with class 'refined-added-to-cart'.
			$('.refined-item-cleared').fadeOut(2000);

			// Update the cart object with the selected product's information.
			cart[pq.attr('name')] = {
				'quantity': not_neg(pq.val(0)), // Call 'not_neg' function to ensure a non-negative quantity value.
				'price': pq.attr('data-product-cost'),
				'gift': pq.attr('data-product-gift-amount'),
				'product': pq.attr('data-product-product-amount')
			};

			// Convert the 'cart' object to a JSON string.
			cart = JSON.stringify(cart);

			// Store the updated cart in the session.
			sessionStorage.setItem('cart', cart);
		}

		/*
		if (pq.val() > 0) {
				$('.refined-btn-clear-item').css('display', 'inline-flex');
		}
		*/

		// Retrieve the 'data-campaign-id' attribute value from 'pq'.
		var campaignid = pq.attr('date-campaign-id');

		$.ajax({
			url: "/wp-json/wewo/v2/evaluate-cart",
			method: "POST",
			//async: false,
			data: {
				cart: JSON.stringify(retrive_cart()),
				goal_id: goal_type() // Call 'goal_type' function to retrieve goal ID and include it in the request.
			},
			beforeSend: function () {
				$('.loading-indicator').addClass('show'); // Show a loading indicator before the request is sent.
			},
			success: function (result) {
				// Execute after a successful AJAX request.
				get_shop_price();
				sessionStorage.setItem('cart', result); // Store the response in the session.
				let cartTotal = total_cart(retrive_cart()); // Calculate and retrieve the total cart value.
				if (sessionStorage.getItem("cart") !== null) {
					// If the cart in session is not empty:
					/*
					FOR AARON: Leaving this here as this is how the if statments were originally.
					$('.refined-added-to-cart').css('display', 'block'); // Show an element with class 'refined-added-to-cart'.
					$('.refined-added-to-cart').fadeOut(2000); 
					$('.refined-to-checkout').css('display', 'inline-flex'); // Show a checkout button.
					

					$('.refined-btn-clear-item').css('display', 'inline-flex');
					$('.refined-cleared-cart').css('display', 'block'); // Show an element with class 'refined-added-to-cart'.
					$('.refined-cleared-cart').fadeOut(2000);
					*/

				} else {
					// Not sure if needed

				}
			},
			error: function (er) {
				$('.loading-indicator').removeClass('show'); // Remove the loading indicator on error.
			},
		});
	}

	$('.refined-to-cart').on('click', updateCart);
	$('.refined-btn-increase-quantity').on('click', { increase: true }, updateCart);
	$('.refined-btn-decrease-quantity').on('click', { decrease: true }, updateCart);
	$('.refined-btn-clear-item').on('click', { clear: true }, updateCart); //Clear item button
	$('.refined-btn-add-to-cart').on('click', { addToCart: true }, updateCart); // attempt at an add item to cart button

	if (sessionStorage.getItem("cart") !== null) {
		if (!jQuery.isEmptyObject(retrive_cart())) {
			$('.WHT-Complete-Order').css('display', 'block');
		}
	}

	$('.quantity-controls').each(function (index) {

		let quantity_input = $(this).find('.product-quantity');
		let sku = $(this).attr('data-sku');
		$(this).find('.plus').on('click', function (event) {
			let qt = parseInt(quantity_input.val()); 1
			quantity_input.val(qt + 1);
			$('input[name=' + sku + '].product-quantity').trigger('change');
		});

		$(this).find('.minus').on('click', function (event) {
			let qt = parseInt(quantity_input.val());
			qt = qt - 1;
			if (qt >= 0) {
				quantity_input.val(qt);
			} else {
				quantity_input.val(0);
			}
			$('input[name=' + sku + '].product-quantity').trigger('change');
		});

	});

	//HERE?
	$('.product-quantity').on('change', function () {
		setTimeout(() => {

			// Get the element with class 'product-quantity'.
			var pq = $(this);

			// Ensure the value of 'pq' is non-negative by calling 'not_neg' function.
			pq.val(not_neg(pq.val()));

			// Retrieve the cart data from the session and parse it into a JavaScript object.
			var cart = sessionStorage.getItem("cart");
			cart = JSON.parse(cart);

			// Update the cart object with the selected product's information.
			cart[pq.attr('name')] = {
				'quantity': not_neg(pq.val()), // Call 'not_neg' function to ensure a non-negative quantity value.
				'price': pq.attr('data-product-cost'),
				'gift': pq.attr('data-product-gift-amount'),
				'product': pq.attr('data-product-product-amount')
			};

			// Convert the 'cart' object to a JSON string.
			cart = JSON.stringify(cart);

			// Store the updated cart in the session.
			sessionStorage.setItem('cart', cart);


			$.ajax({
				url: "/wp-json/wewo/v2/evaluate-cart",
				method: "POST",
				//async: false, 
				data: {
					cart: JSON.stringify(retrive_cart()),
					goal_id: goal_type() // Call 'goal_type' function to retrieve goal ID and include it in the request.
				},
				beforeSend: function (jqXHR, settings) {
					$('.loading-indicator').addClass('show'); // Show a loading indicator before the request is sent.
				},
				success: function (result) {
					sessionStorage.setItem('cart', result); // Store the response in the session.
					var shipping = $("input[name='shipping-type']:checked").val(); // Retrieve the selected shipping type.
					get_shop_price(); // Call 'get_shop_price' function.
					cart = retrive_cart(); // Retrieve the cart data again.
					var grandTotal = grand_total(total_gift_amount(cart), total_product_amount(cart), total_shipping(cart, shipping)); // Calculate the grand total.
					console.log(grandTotal); // Log the grand total to the console.
					var stripe_formated_amount = prepare_for_stripe(grandTotal); // Call 'prepare_for_stripe' function.
					$('.total-amount').html("$" + total_cart(cart)); // Update the element with class 'total-amount' with the cart's total amount.
					$('.shipping-total').html("$" + total_shipping(cart), 'home'); // Update the element with class 'shipping-total' with the shipping total.
					$('.stripe-button').attr("data-amount", stripe_formated_amount); // Update the 'data-amount' attribute of the element with class 'stripe-button'.
					$('.stripe_formated_amount').val(); // Update the value of an element with class 'stripe_formated_amount'.
					$('.total-amount-charge').html("$" + grandTotal); // Update the element with class 'total-amount-charge' with the grand total.
					if (isNaN(stripe_formated_amount)) {
						// If 'stripe_formated_amount' is not a number, set the element's text to "$0".
						$('.total-amount-charge').html("$0");
					}
					let cartTotal = total_cart(retrive_cart());
					$('.loading-indicator').removeClass('show');
					if (!jQuery.isEmptyObject(retrive_cart())) {
						$('.WHT-Complete-Order').css('display', 'block');
					} else {
						$('.WHT-Complete-Order').css('display', 'none');
					}
				},
				error: function (er) {
					$('.loading-indicator').removeClass('show');
				},
			});
		}, 500);
	});

	$.ajax({
		url: "/wp-json/wewo/v2/evaluate-cart",
		method: "POST",
		//async: false,
		data: {
			cart: JSON.stringify(retrive_cart()),
			goal_id: goal_type()
		},
		beforeSend: function () {
			$('.loading-indicator').addClass('show');
		},
		success: function (result) {
			sessionStorage.setItem('cart', result);
			var tc = total_cart(retrive_cart());
			var sa = total_shipping(retrive_cart(), "home");
			var pa = total_product_amount(retrive_cart());

			$('.total-amount').html("$" + tc);
			$('.shipping-total').html("$" + sa);
			var order = retrive_cart();
			$('.stripe-button').attr("data-amount", prepare_for_stripe(grand_total(total_gift_amount(retrive_cart()), total_product_amount(retrive_cart()), total_shipping(retrive_cart(), shipping))));
			$('.stripe_formated_amount').val(prepare_for_stripe(grand_total(total_gift_amount(retrive_cart()), total_product_amount(retrive_cart()), total_shipping(retrive_cart(), shipping)))).on('change', function () {

			});
			$(".total-amount-charge").html("$" + grand_total(total_gift_amount(retrive_cart()), total_product_amount(retrive_cart()), total_shipping(retrive_cart(), shipping)));

			for (var order_key in order) {
				if (order.hasOwnProperty(order_key)) {
					$('.' + order_key).css('display', 'table-row');
					$('input[name=' + order_key + ']').val(not_neg(order[order_key].quantity));
				}

			}
			$('.loading-indicator').removeClass('show');

		},
		error: function (er) {
			$('.loading-indicator').removeClass('show');
		},
	});
	//var stripe = Stripe('pk_test_AM7fsAdgCUJpT98hLhYZIirn');
	//var elements = stripe.elements();

	/* ATS:Note : Removes Shipping from the product cart */
	var cart = retrive_cart();
	delete cart['shipping'];
	cart = JSON.stringify(cart);
	sessionStorage.setItem('cart', cart);
	/*____________________________________________________*/

	document.getElementById('customButton').addEventListener('click', function (e) {
		$.ajax({
			url: "/wp-json/wewo/v2/evaluate-cart",
			method: "POST",
			//async: false,
			data: {
				cart: JSON.stringify(retrive_cart()),
				goal_id: goal_type()
			},
			beforeSend: function () {
				$('.loading-indicator').addClass('show');
			},
			success: function (result) {
				sessionStorage.setItem('cart', result);
				var cart = retrive_cart();
				/*END:   Cart Logging - Phantom Cart  */
				var runstripe = false;
				if ($("input[name='shipping-type']:checked").val() == "host" /*&& $("input[name='sock_recipient']").val() != ""*/) {
					runstripe = true;
				} else {
					if ($("input[name='shipping-type']:checked").val() == "home") {
						runstripe = true;
					} else {
						//$('.recipient-alert').css('display', 'block');
						runstripe = false;
					}

				}
				if (runstripe) {
					/*START:    Adding the shipping as a line item */
					if ($("input[name='shipping-type']:checked").val() == 'home') {
						var shipping = $('.shipping-total').text();
						var cart = cart;
						cart['shipping'] = {
							'quantity': 1,
							'price': shipping.replace('$', ''),
						};
						sessionStorage.setItem('cart', JSON.stringify(cart));
					}
					/*END:   Adding the shipping as a line item  */

					var cart = JSON.stringify(cart);
					var urlParams = new URLSearchParams(window.location.search);
					/** 
					 * Conditional for the student name.
					 *  @author Aaron Blakeley
					 **/

					var studentcredit = $('input[name="student"]').val() ===  undefined ? $('select[name="student"]').val() : $('input[name="student"]').val();
					
					var compiled = JSON.stringify({
						personalnote: $('textarea[name="personal-note"]').val(), 
						phone: $('input[name="phone_number"]').val(),
						shipping_type: $('input[name="shipping-type"]:checked').val(),
						sock_recipient: $('input[name="sock_recipient"]').val(),
						county: $('select[name="customer_county"]').find(":selected").val(),
						credit: studentcredit,
						order_name: $('input[name="first_name"]').val() + ' ' + $('input[name="last_name"]').val(),
						email: $('input[name="their_email"]').val(),
						your_name: $('input[name="first_name"]').val() + ' ' + $('input[name="last_name"]').val(),
						club: $('select[name="customer_club"').find(":selected").val(),
					});
					$.ajax({
						url: "/wp-json/wewo/v2/cart-session",
						method: "POST",
						data: { wewocart: cart, campaign: urlParams.get('campaignid'), compiled: compiled, state: $('.stateselect').val() },
						success: function (result) {
							sessionStorage.setItem('cart-token', JSON.stringify(result));
							if ($('body').hasClass('wewo_debug_on')) {
								var stripe = Stripe('pk_test_AM7fsAdgCUJpT98hLhYZIirn');
							} else {
								var stripe = Stripe('pk_live_b03c2TWUSyDX5agzTe5t2OqR00rinYwf0F');
							}
							return stripe.redirectToCheckout({ sessionId: result.id });
						},
						error: function (er) {
							console.log(er);
						},
					});

					e.preventDefault();
				} else {
					e.preventDefault();
				}
				$('.loading-indicator').removeClass('show');
			},
			error: function (er) {
				$('.loading-indicator').removeClass('show');
			},
		});


	});
	$.ajax({
		url: "/wp-json/wewo/v2/evaluate-cart",
		method: "POST",
		//async: false,
		data: {
			cart: JSON.stringify(retrive_cart()),
			goal_id: goal_type()
		},
		beforeSend: function () {
			$('.loading-indicator').addClass('show');
		},
		success: function (result) {
			sessionStorage.setItem('cart', result);
			$('.loading-indicator').removeClass('show');
			$('.total-amount-charge').html("$" + grand_total(total_gift_amount(retrive_cart()), total_product_amount(retrive_cart()), total_shipping(retrive_cart(), shipping)));
			check_the_button();
		},
		error: function (er) {
			$('.loading-indicator').removeClass('show');
		},
	});

	

	/*END:   Start Cart Logic  */
});
